import { BASE_API_URL } from '../consts/base-url';
import customFetch from './fetch';

// Best-effort keepalive beacon to pause a task on tab/page close
export const signalPauseTask = (taskId: number) => {
  void customFetch(`${BASE_API_URL}/tasks/${taskId}/update`, {
    method: 'POST',
    keepalive: true,
    body: JSON.stringify({
      newStatus: 'PAUSED'
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
};